import {SET} from '../';
import {UserBehaviorsService, Webshop} from '@/services';
import {WebshopProduct} from "@/services/models";

export default {
    namespaced: true,
    state: {
        behaviorsList: [],
        purchasedProducts: []
    },
    getters: {
        get(state) {
            return key => state[key];
        }
    },
    mutations: {
        SET
    },
    actions: {
        async getBehaviorsByTypes({commit}, payload) {
            let response = await UserBehaviorsService.GetUserBehaviorsByTypes(payload);
            commit('SET', {key: 'behaviorsList', value: response.data.Value});
        },

        async fetchPurchaseHistory({commit, dispatch}, payload) {
            let response = await UserBehaviorsService.GetPurchaseHistory(payload);
            if (!response.data.RecentlyBoughtProducts?.length) return;
            let productsResponse = await Webshop.GetProductsByIds({
                chainId: payload.chainId,
                productIds: response.data.RecentlyBoughtProducts.map(x => x.ProductId)
            });

            let products = productsResponse.data.ProductList.map(product => new WebshopProduct(product));

            products.forEach((p) => {
                if (p.productDetails) {
                  let campaign = p.productDetails.campaigns.length > 1 && p.discounts?.length ? p.productDetails.campaigns.find((c) => c.CampaignId == p.discounts[0]?.CampaignId) : p.productDetails.campaigns[0];
                    
                  p.bestCampaign = campaign;
                  p.salePrice = (campaign?.PromotionType === 4 || campaign?.PromotionType == 1) ? p.productDetails.price :  p.discounts?.length? p.discounts[0]?.DiscountPrice : p.productDetails.price;
                }
            });
            
            commit('SET', {key: 'purchasedProducts', value: products});
        },

        async createOrUpdateUserBehaviors({commit}, payload) {
            let response = await UserBehaviorsService.CreateOrUpdateUserBehaviors(payload);
            return response.data.BooleanValue;
        },

        setPurchaseHistory({commit}, products){
            commit('SET', {key: 'purchasedProducts', value: products});
        }
    }
};
